import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import FormDate from "../Form/FormDate";
// import { DatePicker, TimePicker } from 'material-ui-pickers';

class ParticipationFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    toggleCompany(e) {
        this.props.handleChange(e);
        this.state.showCompany = ! this.state.showCompany;
    }

    render() {
        const {
            values,
            course,
            persons,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFormikState,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="id_course" value={values.id_course} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            disabled
                            autoComplete={false}
                            name="course_name"
                            label={i18n.get('schedules.course_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={course.name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="id_person"
                            label={i18n.get('participations.student')}
                            url="/search-student"
                            onChange={option => {
                                values.id_person = option.value;
                                if ( option.entity ) {
                                    values.student = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.student && [{
                                'value': values.student.id,
                                'label': getPersonName(values.student),
                                'entity': values.student,
                            }]}
                            value={values.student && {
                                'value': values.student.id,
                                'label': getPersonName(values.student),
                                'entity': values.student,
                            }}
                            error={errors.id_person}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="date"
                            name="day_course_entry"
                            label={i18n.get('participations.day_course_entry')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day_course_entry}
                            error={errors.day_course_entry}
                            touched={touched.day_course_entry}
                        />
                    </Grid>
                    {isEdit &&
                        <Grid item xs={12} sm={2}>
                            <FormDate
                                type="date"
                                name="day_course_withdrawel"
                                label={i18n.get('participations.day_course_withdrawel')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.day_course_withdrawel}
                                error={errors.day_course_withdrawel}
                                touched={touched.day_course_withdrawel}
                            />
                        </Grid>
                    }
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/participations/${values.id}`}
                                confirmMessage={i18n.get('participations.confirm_message')}
                                successMessage={i18n.get('participations.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('participations.update') : i18n.get('participations.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default ParticipationFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Participations/ParticipationFormFields.js